import { BaseGenerator } from '../core/BaseGenerator.js';
import { ChecksumCalculator } from '../utils/ChecksumCalculator.js';

/**
 * Canadian SIN generator following Single Responsibility Principle
 */
export class SinGenerator extends BaseGenerator {
  generate(options = {}) {
    const { formatted = true } = options;

    // Generate first 8 digits
    const firstEight = this.randomDigits(8);
    
    // Calculate check digit using Luhn algorithm
    let sum = 0;
    for (let i = 0; i < 8; i++) {
      let digit = parseInt(firstEight[i]);
      
      if (i % 2 === 1) {
        digit *= 2;
        if (digit > 9) {
          digit = Math.floor(digit / 10) + (digit % 10);
        }
      }
      
      sum += digit;
    }

    const checkDigit = (10 - (sum % 10)) % 10;
    const sin = firstEight + checkDigit;

    return formatted ? `${sin.substring(0, 3)} ${sin.substring(3, 6)} ${sin.substring(6, 9)}` : sin;
  }
}